module.exports = __webpack_public_path__ + "static/media/shopping-bag-dark.641e6d3b.svg";